import signedFetch from '../util/signedFetch.js';

export default (orgId, body) =>
  signedFetch(
    'archiveLearningAssignments',
    `${__API_BASE__}/org/${encodeURIComponent(orgId)}/archiveAssignments`,
    'POST',
    body
  );
